<span (click)="onRemoveDebugTag()" *ngIf="shouldShowDebugTag">
  {{ environmentName }}
</span>
